import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Workout } from "@/schemas/workout";

interface ReadyWorkoutProps {
  workout: Workout | null;
  onStartWorkout: () => void;
}

export default function ReadyWorkout({
  workout,
  onStartWorkout,
}: ReadyWorkoutProps) {
  if (!workout) return null;

  return (
    <div className="container max-w-md mx-auto p-4">
      <Card>
        <CardContent className="pt-6">
          <div className="text-center">
            <h1 className="text-2xl font-bold mb-4">{workout.name}</h1>
            <p className="mb-6">{workout.description}</p>
            <Button onClick={onStartWorkout} size="lg" className="w-full">
              Start Workout
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
